import script from "./SidebarOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarOrganism.vue?vue&type=script&setup=true&lang=js"

import "./SidebarOrganism.css?vue&type=style&index=0&Scoped=true&lang=css&external"

const __exports__ = script;

export default __exports__